module.exports = __webpack_public_path__ + "img/ml.a0dcd647.svg";